import { render, staticRenderFns } from "./ScoreBoard.vue?vue&type=template&id=6ea88586&scoped=true&"
import script from "./ScoreBoard.vue?vue&type=script&lang=ts&"
export * from "./ScoreBoard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea88586",
  null
  
)

export default component.exports